module.exports = __webpack_public_path__ + "img/ereszkalkulator_haz_osszetett_nyeregteto_szines.d8636d03.png";